import React from 'react'

const orEmpty = (value) => {
  return value || ''
}

export { orEmpty }